import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromPaymentConfig from './payment-config.reducers';

export interface PaymentConfigState {
  stateData: fromPaymentConfig.State;
}

export interface State extends fromRoot.AppState {
  paymentConfig: PaymentConfigState;
}

export const reducers = {
  stateData: fromPaymentConfig.reducer
};

export const selectPaymentConfigState = createFeatureSelector<PaymentConfigState>('paymentConfig');

export const selectPaymentConfigStateData = createSelector(selectPaymentConfigState, (state: PaymentConfigState) => state.stateData);

export const getPaymentConfigState = createSelector(selectPaymentConfigStateData, fromPaymentConfig.getStateData);

export const getPaymentConfigScreenError = createSelector(selectPaymentConfigStateData, fromPaymentConfig.getError);

export const getPaymentConfigScreenPending = createSelector(selectPaymentConfigStateData, fromPaymentConfig.getPending);

export const getSubsectionsState = createSelector(selectPaymentConfigStateData, fromPaymentConfig.getSubsectionData);

export const getPaymentOptionState = createSelector(selectPaymentConfigStateData, fromPaymentConfig.getPaymentOptionData);

export const getPaymentProcessorState = createSelector(selectPaymentConfigStateData, fromPaymentConfig.getPaymentProcessornData);